/**
 * Get List
 */
export const REVIEWER_BOARD_LIST = "REVIEWER_BOARD_LIST";
export const REVIEWER_BOARD_LIST_SUCCESS = "REVIEWER_BOARD_LIST_SUCCESS";
export const REVIEWER_BOARD_LIST_FAILURE = "REVIEWER_BOARD_LIST_FAILURE";

/**
 * CREATE
 */
export const REVIEWER_BOARD_CREATE = "REVIEWER_BOARD_CREATE";
export const REVIEWER_BOARD_CREATE_SUCCESS = "REVIEWER_BOARD_CREATE_SUCCESS";
export const REVIEWER_BOARD_CREATE_FAILURE = "REVIEWER_BOARD_CREATE_FAILURE";

/**
 * GET BY ID
 */
export const REVIEWER_BOARD_GET = "REVIEWER_BOARD_GET";
export const REVIEWER_BOARD_GET_SUCCESS = "REVIEWER_BOARD_GET_SUCCESS";
export const REVIEWER_BOARD_GET_FAILURE = "REVIEWER_BOARD_GET_FAILURE";

/**
 * UPDATE BY ID
 */
export const REVIEWER_BOARD_UPDATE = "REVIEWER_BOARD_UPDATE";
export const REVIEWER_BOARD_UPDATE_SUCCESS = "REVIEWER_BOARD_UPDATE_SUCCESS";
export const REVIEWER_BOARD_UPDATE_FAILURE = "REVIEWER_BOARD_UPDATE_FAILURE";

/**
 * DELETE BY ID
 */
export const REVIEWER_BOARD_DELETE = "REVIEWER_BOARD_DELETE";
export const REVIEWER_BOARD_DELETE_SUCCESS = "REVIEWER_BOARD_DELETE_SUCCESS";
export const REVIEWER_BOARD_DELETE_FAILURE = "REVIEWER_BOARD_DELETE_FAILURE";